<template>
  <div class="success_box">
    <div class="inners">
      <div class="right">
        <div>
          <el-icon style="color:#72c140;font-size: 58px">
            <SuccessFilled/>
          </el-icon>
        </div>
        <div class="inner_text">
          <span class="text" v-if="routeData.groupType">
            {{ $t('group.send.task.submit') }}
          </span>

          <!-- 解决 texts 翻译不出来：使用 transText -->
          <span class="text" v-else>{{ $t('common.email') }}{{ transText }}!</span>

          <!-- 成功发送邮件 -->
          <span v-if="isSendSuccessOk" style="margin-top: 8px">
            {{ $t('common.yjbcz') }}
            <el-button link type="primary" @click="toSend">
              {{
                routeData.sendTime
                    ? `「${$t('common.draftsbox')}」`
                    : routeData.groupType
                        ? `「${$t('group.send.task.list')}」`
                        : `「${$t('common.has.sent')}」`
              }}
            </el-button>
          </span>

          <!-- 保存成功 -->
          <span v-if="isSaveSuccess" style="margin-top: 8px">
            {{ $t('common.yjbcz') }}
            <el-button link type="primary" @click="toDraf">「{{ $t('common.draftsbox') }}」</el-button>
          </span>

          <span style="margin-top: 17px">
            <span style="vertical-align: sub;"><img src="@/assets/write.png" width="16" height="16"/></span>
            <el-button link type="primary" @click="requestAgain">
              {{ $t('common.team.toWriteLetter') }}
            </el-button>
          </span>
        </div>

        <!-- 邮件客户区域 -->
        <div class="area_box" v-if="isSendSuccessOk && routeData.flag==='1'">
          <div>
            <div class="left">
              <span>{{ $t('group.send.belong.customer') }}</span>
              <div style="text-align: center;line-height: 28px;" v-for="item in routeData.to" :key="item.email">
                {{ item.email }}
              </div>
            </div>
            <div class="right">
              <el-button link type="primary" @click="addTargetCustomer">
                {{ $t('common.khjd') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 对话框们 -->
  <ReturnEmails
      ref="emailsReturn"
      v-if="dialogVisible"
      v-model="dialogVisible"
      @close="close"
      @createCustomer="createdNewCustomer"
      :targetEmail="routeData.to"
  />

  <CustomerCreated
      ref="customerCreated"
      v-if="dialogVisibleCreatedMessage"
      v-model="dialogVisibleCreatedMessage"
      @close="closeCreated"
      :innerDialog="dialogVisible"
      @changeInnerDialog="close"
  />
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref, onMounted, nextTick, computed, getCurrentInstance} from "vue";
import {Base64} from "js-base64";
import {useStore} from "vuex";
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import CustomerCreated from "@/components/DiaPops/Returns/CustomerCreated.vue";

const store = useStore()
const router = useRouter();
const route = useRoute()

const dialogVisible = ref(false)
const dialogVisibleCreatedMessage = ref(false)
const emailsReturn = ref(null)

// 取全局翻译函数
const {appContext} = getCurrentInstance()
const $t = appContext.config.globalProperties.$t.bind(appContext.config.globalProperties)

// texts 原始值（可能是 key，也可能是已翻译的文字）
const texts = ref('')
const routeData = ref({})

// 解决：texts 翻译不成功 → 统一通过 computed 翻译
const transText = computed(() => {
  if (!texts.value) return '';
  try {
    return $t(texts.value);
  } catch {
    return texts.value;
  }
});

// 标准判断（兼容 texts 是 key 或翻译文本）
const isSendSuccessOk = computed(() => {
  const key = 'common.email.list.sendSuccessOk';
  return texts.value === key || $t(texts.value) === $t(key);
});

const isSaveSuccess = computed(() => {
  const key = 'sys.message.success.save';
  return texts.value === key || $t(texts.value) === $t(key);
});

onMounted(() => {
  try {
    const q = route.query.q;
    if (q) {
      const decoded = JSON.parse(Base64.decode(q));
      routeData.value = decoded;
      texts.value = decoded?.text || '';
    }
  } catch (e) {
    console.error("decode error:", e);
  }
});

// 重新写邮件
const requestAgain = () => {
  const q = route.query.q;
  if (!q) return;
  let decoded = JSON.parse(Base64.decode(q));

  if (decoded.groupType) {
    router.push({
      path: '/email/send_all',
      query: {
        massTaskId: decoded.massTaskId,
        customerId: decoded.customerId,
        type: decoded.groupType === "1" ? 1 : 2,
        flag: 'again',
      }
    })
  } else {
    router.push({
      path: '/email/write_mail',
      query: {
        id: decoded.emailId,
        type: "resend",
        customerId: decoded.customerId,
        flag: 'again'
      }
    })
  }
};

// 跳转查看发送结果
const toSend = () => {
  const q = route.query.q;
  if (!q) return;
  const decoded = JSON.parse(Base64.decode(q));

  if (decoded.groupType) router.push('/email/customer/sending');
  else if (decoded.sendTime) router.push("/email/draft");
  else router.push('/email/has_send');
};

const toDraf = () => router.push('/email/draft');

// 添加目标客户
const addTargetCustomer = async () => {
  dialogVisible.value = true;
  await nextTick();
  emailsReturn.value.getAllCustomers();
};

const close = () => dialogVisible.value = false;
const closeCreated = () => dialogVisibleCreatedMessage.value = false;

// 创建新客户
const createdNewCustomer = async () => {
  dialogVisibleCreatedMessage.value = true;
  await store.commit('customer/setRuleForm', {
    zoneCode: "",
    customerCode: "",
    zoneAddress: "",
    customerName: "",
    setUpTime: "",
    economicNature: "",
    companyWebsite: "",
    companyAddress: "",
    phoneWayList: [],
    emailWayList: [],
    companyFax: "",
    companyRemark: "",
    customerLevel: "",
    customerType: "",
    customerTypeId: "",
    product: "",
    marketingRemark: " ",
    createBy: "",
    branchAdmin: "",
    mangerVOList: [{managerName: ''}]
  });
  await store.commit('customer/setForm', {
    phones: [{phoneNumber: "", isDefault: true}],
    emails: [{email: "", isDefault: true}],
  });
};
</script>

<style lang="less" scoped>
@import "../Customer/less/detail.less";

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.success_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background: #f5f5f5;
  height: calc(100vh - 48px);
  padding-top: 47px;

  .text {
    height: 32px;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 32px;
  }

  .inner_text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);

    a {
      color: #1890FF;
    }
  }

  .area_box {
    width: 575px;
    background: #EAF3FB;
    margin-top: 28px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 20px;
    }
  }
}

.inners {
  width: 1000px;
  background: white;
  padding-top: 58px;

  .right {
    padding-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>